/**
 * PDP: main gallery scroll → thumbnail strip sync (data-slide + active).
 * Standalone; does not modify slider.js. Tune when you go live.
 */
(function () {
  const BOUND = "data-thumb-sync-bound";

  function getSlides(track) {
    return Array.from(track.children);
  }

  function activeIndexFromScroll(scroller, slides) {
    if (!slides.length) return 0;
    const viewCenter = scroller.scrollLeft + scroller.clientWidth / 2;
    let best = 0;
    let bestDist = Infinity;
    slides.forEach((slide, i) => {
      const mid = slide.offsetLeft + slide.offsetWidth / 2;
      const d = Math.abs(viewCenter - mid);
      if (d < bestDist) {
        bestDist = d;
        best = i;
      }
    });
    return Math.min(slides.length - 1, Math.max(0, best));
  }

  function isVerticalRail() {
    return window.matchMedia("(min-width: 768px)").matches;
  }

  function isDotsTrack() {
    return !window.matchMedia("(min-width: 768px)").matches;
  }

  function updateCounter(container, idx) {
    const current = container.querySelector("[data-slider-counter-current]");
    if (current) current.textContent = idx + 1;
  }

  function applyThumbState(
    container,
    secondaryScroller,
    secondarySlides,
    idx,
    reposition
  ) {
    secondarySlides.forEach((slide, i) => {
      const shouldBeActive = i === idx;
      const isActive = slide.getAttribute("active") === "true";
      if (shouldBeActive !== isActive) {
        slide.setAttribute("active", shouldBeActive ? "true" : "false");
      }
    });
    updateCounter(container, idx);
    if (!reposition) return;
    const target = secondarySlides[idx];
    if (!target) return;
    if (isVerticalRail()) {
      const trackRect = secondaryScroller.getBoundingClientRect();
      const targetRect = target.getBoundingClientRect();
      const targetTopInTrack =
        targetRect.top - trackRect.top + secondaryScroller.scrollTop;
      const targetBottomInTrack = targetTopInTrack + targetRect.height;
      const visibleTop = secondaryScroller.scrollTop;
      const visibleBottom = visibleTop + secondaryScroller.clientHeight;

      let top = visibleTop;
      if (targetTopInTrack < visibleTop) {
        top = targetTopInTrack;
      } else if (targetBottomInTrack > visibleBottom) {
        top = targetTopInTrack;
      }

      secondaryScroller.scrollTo({ top, behavior: "smooth" });
    } else if (isDotsTrack()) {
      // offsetLeft is relative to wyatt-slider (the offsetParent), not the
      // track's own scroll content box, because the prev/next arrows sit
      // before/after the track as real flex siblings in dots mode. Use
      // bounding rects (viewport space) instead so the math is anchored to
      // the track itself regardless of what flex siblings precede it.
      const trackRect = secondaryScroller.getBoundingClientRect();
      const targetRect = target.getBoundingClientRect();
      const targetLeftInTrack =
        targetRect.left - trackRect.left + secondaryScroller.scrollLeft;
      const targetRightInTrack = targetLeftInTrack + targetRect.width;
      const visibleLeft = secondaryScroller.scrollLeft;
      const visibleRight = visibleLeft + secondaryScroller.clientWidth;
      const indicatorSize =
        parseFloat(
          getComputedStyle(target).getPropertyValue(
            "--product-media-dots-indicator-size"
          )
        ) || targetRect.width;
      const center =
        targetLeftInTrack +
        targetRect.width / 2 -
        secondaryScroller.clientWidth / 2;

      let left = visibleLeft;
      if (targetLeftInTrack < visibleLeft) {
        const overflow = visibleLeft - targetLeftInTrack;
        left = overflow > indicatorSize ? center : targetLeftInTrack;
      } else if (targetRightInTrack > visibleRight) {
        const overflow = targetRightInTrack - visibleRight;
        left =
          overflow > indicatorSize
            ? center
            : targetRightInTrack - secondaryScroller.clientWidth;
      }

      secondaryScroller.scrollTo({
        left: Math.max(0, left),
        behavior: "smooth",
      });
    } else {
      secondaryScroller.scrollTo({ left: target.offsetLeft, behavior: "smooth" });
    }
  }

  function bindContainer(container) {
    if (container.getAttribute(BOUND) === "true") return;

    const primaryScroller = container.querySelector(
      ".product-media__primary [data-slider]"
    );
    const secondaryScroller = container.querySelector(
      ".product-media__secondary [data-slider]"
    );
    if (!primaryScroller || !secondaryScroller) return;

    const slidesP = getSlides(primaryScroller);
    const slidesS = getSlides(secondaryScroller);
    if (!slidesP.length || slidesP.length !== slidesS.length) return;

    container.setAttribute(BOUND, "true");

    let scrollEndTimer = null;

    const syncActiveAndPosition = () => {
      const idx = activeIndexFromScroll(primaryScroller, slidesP);
      applyThumbState(container, secondaryScroller, slidesS, idx, true);
    };

    const onScroll = () => {
      clearTimeout(scrollEndTimer);
      scrollEndTimer = setTimeout(syncActiveAndPosition, 120);
    };

    primaryScroller.addEventListener("scroll", onScroll, { passive: true });
    primaryScroller.addEventListener("scrollend", syncActiveAndPosition, {
      passive: true,
    });
  }

  function scan() {
    document.querySelectorAll("[data-product-media]").forEach(bindContainer);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", scan);
  } else {
    scan();
  }

  const mo = new MutationObserver(scan);
  mo.observe(document.documentElement, { childList: true, subtree: true });
})();
